export const EMAIL_MAX_LENGTH = 75

interface IsEmailLocalPartTooLongProps {
  email: string
  maxLength?: number
}

interface IsEmailLocalPartTooLongReturn
  extends Pick<IsEmailLocalPartTooLongProps, 'maxLength'> {
  isTooLong: boolean
}

export function isEmailLocalPartTooLong({
  email,
  maxLength = 55,
}: IsEmailLocalPartTooLongProps): IsEmailLocalPartTooLongReturn {
  const [localPart] = email.split('@')

  if (!localPart) {
    return { isTooLong: false, maxLength }
  }

  return {
    isTooLong: localPart.length > maxLength,
    maxLength,
  }
}
